import React from "react";

import logo from "../images/hex-logo.svg"

export default class Header extends React.Component {
    constructor () {
        super();
        this.clickHandler = this.clickHandler.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
    }

    clickHandler (e) {
        this.props.handleClick(e.target.id);
    }

    renderHeader = () => {
        if (this.props.isBrowser === 1) {
            return (
                <nav className="navbar navbar-default menu-container">
                    <div className="container-fluid">
                        <div className="navbar-brand">
                            <a id="Home" onClick={this.clickHandler}>Kent Pham Studio</a>
                            <img className="app-logo" src={logo} width="40px" alt="Kent Pham Studio Logo"></img>
                        </div>

                        <ul className="nav">
                            <li className="nav-item"><a id="Home" onClick={this.clickHandler}>Home</a></li>
                            <li className="nav-item"><a id="Portfolio" onClick={this.clickHandler}>Portfolio</a></li>
                            <li className="nav-item"><a id="Resume" onClick={this.clickHandler}>Resume</a></li>
                            <li className="nav-item"><a id="Contact" onClick={this.clickHandler}>Contact</a></li>
                        </ul>

                    </div>
                </nav>
            );
        } else {
            return (
                <nav className="navbar navbar-default menu-container">
                    <div className="container-fluid">
                        <div className="centering-div">
                            <div className="navbar-brand">
                                <a id="Home" onClick={this.clickHandler}>Kent Pham Studio</a>
                            </div>
                        </div>
                        <div className="centering-div brand-div">
                            <img className="app-logo" src={logo} width="40px"></img>
                        </div>
                        <div className="centering-div">
                            <ul className="nav">
                                <li className="nav-item nav-one"><a id="Home" onClick={this.clickHandler}>Home</a></li>
                                <li className="nav-item"><a id="Portfolio" onClick={this.clickHandler}>Portfolio</a></li>
                                <li className="nav-item"><a id="Resume" onClick={this.clickHandler}>Resume</a></li>
                                <li className="nav-item"><a id="Contact" onClick={this.clickHandler}>Contact</a></li>
                            </ul>
                        </div>

                    </div>
                </nav>
            );
        }
    }

    render() {
        return this.renderHeader();
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js